import { z } from 'zod';
import { CalendarEventType, DocumentType } from '@/features/calendar/types/calendar-dto';
import { BookingStatus } from '@/features/superAdmin/features/data/types/superAdmin-data.types';

export const SuperAdminBookingEditFormSchema = z
    .object({
        hotelId: z.string().min(1),
        apartmentId: z.string().nullable(),
        checkInDate: z.date({ required_error: 'Required' }),
        checkOutDate: z.date({ required_error: 'Required' }),
        guestFullName: z.string().nullable(),
        remarks: z.string().nullable(),
        eventType: z.nativeEnum(CalendarEventType),
        documentType: z.nativeEnum(DocumentType),
        bookingStatus: z.nativeEnum(BookingStatus),
        numberOfRooms: z.coerce.number().int().min(0),
        totalAmount: z.coerce.number().min(0),
        isActive: z.boolean(),
        hasAccommodation: z.boolean(),
        documentNumber: z.string().nullable(),
        documentDate: z.date({ required_error: 'Required' }),
        externalId: z.string().nullable(),
    })
    .refine((data) => data.checkOutDate > data.checkInDate, {
        message: 'Check-out must be after check-in',
        path: ['checkOutDate'],
    });

export type SuperAdminBookingEditFormData = z.infer<typeof SuperAdminBookingEditFormSchema>;
